import React, { FC } from 'react';
import { LabelWrapper } from './style';
import Barcode from 'react-barcode';
import { QRCode } from 'react-qr-svg';

type Props = {
  data: any;
  nextPage: number;
};

const Label: FC<Props> = ({ data, nextPage }: Props): React.ReactElement => {
  const flatFeatures = (items: any) => {
    const features: string[] = [];
    if (items.featureValues) {
      items.featureValues.forEach(
        (el: { featureName: string; valueName: string }) => {
          features.push(`${el.featureName}: ${el.valueName}`);
        },
      );
    }
    return features;
  };
  return (
    <LabelWrapper className={`${!nextPage && 'nextPage'}`}>
      <div className="variant">
        {/* <span className="partner-info">
          {(
            data?.partnerName + (data.sellerName ? ` (${data.sellerName})` : '')
          ).substring(0, 45)}
        </span> */}
        {/* <Barcode
          textPosition={'top'}
          textAlign="left"
          fontOptions={'bold'}
          height={'30px'}
          fontSize={8}
          value={data.variantId}
        /> */}
        <span className="variant-id">{data.variantId}</span>
        <span className='product-code'>{data.productCode}</span>
        <div className='qr-container'>
          <QRCode
            // style={{ width: '20%' }}
            value={
              data.serialNumber
                ? data.serialNumber
                : 'null'
            }
          />
        </div>
        <div className="product">
          <span style={{fontSize: data.productName.length > 120 ? '7px' : '8px'}}>
            {data.productName}{' '}
            {`${data?.featureValues?.length
              ? `-` + flatFeatures(data)?.join(',')?.slice(0, 10)
              : ''
              }`}
          </span>
        </div>
      </div>
      <div className="inventory">
        <Barcode
          width={1.4}
          textPosition={'top'}
          textAlign="center"
          fontSize={12}
          value={data.serialNumber}
          height={'33px'}
          fontOptions={'bold'}
        />
      </div>
    </LabelWrapper>
  );
};

export default Label;
